'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationTypeId = void 0;
/**
 * Verification types
 */
var VerificationTypeId;
(function (VerificationTypeId) {
    VerificationTypeId[VerificationTypeId["SMS"] = 1] = "SMS";
    VerificationTypeId[VerificationTypeId["EMAIL"] = 2] = "EMAIL";
    VerificationTypeId[VerificationTypeId["SMS_AND_EMAIL"] = 3] = "SMS_AND_EMAIL";
    VerificationTypeId[VerificationTypeId["MANUAL"] = 4] = "MANUAL";
})(VerificationTypeId = exports.VerificationTypeId || (exports.VerificationTypeId = {}));
